// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"294b2f28","453":"f2462866","667":"bb10edeb"}[chunkId] + ".chunk.js";
};